import { API_endpoints } from "../config";
import { BookingFormValues } from "modules/booking-popup";

export const setsEmployBooking = async (formDate: BookingFormValues) => {
    try {
        const response = await fetch(API_endpoints.setsEmployBooking, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(formDate),
        });
        
       
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Daten.");
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Fehler bei der Buchungsanfrage:", error);
        throw error;
    }
};
